import React from 'react';
import { useLanguage } from '../translations/LanguageContext';
import { MapPin, Phone, Mail, Clock, MessageCircle } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-primary text-primary-foreground py-12 px-4">
      <div className="container max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo & About */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_traditional-medicine-3/artifacts/f5y9qdpg_Logo.png" 
              alt="Tranquil Acupuncture" 
              className="h-20 w-auto mb-4"
            />
            <p className="body-small opacity-90">
              {t.footer.tagline}
            </p>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="body-medium font-semibold mb-4 text-accent-primary">{t.footer.contact}</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-2 body-small opacity-90">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Plaza del Bulevar, 13<br />29649 La Cala de Mijas<br />Málaga, Spain</span>
              </div>
              <div className="flex items-center gap-2 body-small opacity-90">
                <Phone size={16} className="flex-shrink-0" />
                <a href="tel:+34641654334" className="hover:underline">+34 641 654 334</a>
              </div>
              <div className="flex items-center gap-2 body-small opacity-90">
                <MessageCircle size={16} className="flex-shrink-0" />
                <a href="https://wa.me/34641654334" target="_blank" rel="noopener noreferrer" className="hover:underline">WhatsApp</a>
              </div>
              <div className="flex items-center gap-2 body-small opacity-90">
                <Mail size={16} className="flex-shrink-0" />
                <a href="mailto:acutranquil@gmail.com" className="hover:underline break-all">acutranquil@gmail.com</a>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3 className="body-medium font-semibold mb-4 text-accent-primary">{t.footer.hours}</h3>
            <div className="space-y-2 body-small opacity-90">
              <div className="flex items-center gap-2">
                <Clock size={16} />
                <span className="font-semibold">{t.contact.hoursWeekday}</span>
              </div>
              <p className="pl-6">{t.contact.hoursWeekdayTime}</p>
              <div className="flex items-center gap-2 mt-3">
                <Clock size={16} />
                <span className="font-semibold">{t.contact.hoursWeekend}</span>
              </div>
              <p className="pl-6">{t.contact.hoursWeekendTime}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-6 text-center">
          <p className="body-small opacity-75">
            {t.footer.copyright.replace('{year}', currentYear)}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
